import { CapoPlugin } from "/codebuild/output/src271734474/src/gx-booking/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.5.41/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];